import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qe6cjwf7wv: FaireBrandEntity = {
  token: "b_qe6cjwf7wv",
  type: "brand",
  name: "Mama Teav's",
  avatarUrl:
    "https://cdn.faire.com/fastly/7aa10091d2385308e80d26f95845bcdf4bef2fc5c239eb6d24d83bc10e3ccc18.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ef0d67548b39cb80ad14c95d1c6b5ac7634341c2e70079b6f0ac18a95d2c9f7f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7aa10091d2385308e80d26f95845bcdf4bef2fc5c239eb6d24d83bc10e3ccc18.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ef0d67548b39cb80ad14c95d1c6b5ac7634341c2e70079b6f0ac18a95d2c9f7f.png",
  location: "Oakland, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 28,
  isTopShop: true,
  isInsider: true,
  description:
    "Mama Teav’s Hot Garlic is an all natural chili crisp brand built around bold flavor and intentional ingredients. We make an extroverted, crave-worthy chili crisp using only 7 all-natural ingredients, including cold-pressed grapeseed oil sourced from Napa Valley—no refined sugar, no shortcuts.\n\nRooted in Southeast Asian flavors but made for everything, Mama Teav’s is designed to be the most versatile chili crisp on the market. From eggs and noodles to pizza and roasted vegetables, our chili crisp delivers infinite possibilities with simple ingredients and unapologetically big flavor.\n\n::No allergins or refined sugar::Gluten Free::Vegan::",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:46.648Z",
    importedBy: "entity-db-cli",
  },
};
